import apiService from "../../api/api.service";
import {
  CitiesResponse,
  DistrictsResponse,
  NeighbourhoodsResponse,
  GetCitiesRequest,
  GetDistrictsRequest,
  GetNeighbourhoodsRequest,
} from "./location.types";

/**
 * Get cities list
 */
export const getCities = (params?: GetCitiesRequest) => {
  return apiService.get<CitiesResponse>("/general/cities", { params });
};

/**
 * Get districts by city
 */
export const getDistricts = (params: GetDistrictsRequest) => {
  return apiService.get<DistrictsResponse>("/general/districts", { params });
};

/**
 * Get neighbourhoods by district
 */
export const getNeighbourhoods = (params: GetNeighbourhoodsRequest) => {
  return apiService.get<NeighbourhoodsResponse>("/general/neighbourhoods", { params });
};
